"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Icon = function (_a) {
    var _b = _a.color, color = _b === void 0 ? '#000' : _b;
    return (react_1.default.createElement("svg", { width: "24", height: "25", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("path", { d: "M21 12a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.379 8.379 0 0 1-3.8-.9L3 21.5l1.9-5.7A8.38 8.38 0 0 1 4 12a8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z", stroke: color, strokeLinecap: "round", strokeLinejoin: "round" })));
};
exports.default = Icon;
//# sourceMappingURL=MessageCircle.js.map